import { PageHeader } from "@/components/PageHeader";
import { ProductionReportView } from "@/features/production-report";

// Spec 083 (T040) — a tela dedicada. A mesma composição aparece como aba do detalhe da linha, com
// o recorte travado: um componente só, dois lugares.
export function ProductionReportPage() {
  return (
    <section>
      <PageHeader
        title="Controle de produção"
        subtitle="Quanto entrou, quanto saiu, em que produto e qual foi o aproveitamento."
      />
      <ProductionReportView />
    </section>
  );
}
